<template>
  <v-container
    tag="section"
  >
    <base-material-card
      color="coolrunner"
      icon="credit_card"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="text-h2 font-weight-light">
          {{ $t('quickpay') }} {{ $t('subscriptions') }}
        </div>
      </template>
      <v-row class="mx-0">
        <v-col cols="6">
          <filter-main
            :filter-options="filterOptions"
            :filter-actions="filterActions"
            :filter="filter"
            @set-filter="setFilter"
          />
        </v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto"
          :label="$t('search')"
          hide-details
          single-line
          style="max-width: 250px;"
          @keydown.enter="getDataFromApi"
          @blur="getDataFromApi"
        />
      </v-row>

      <v-divider class="my-3" />

      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 50, 100]
        }"
        dense
        class="elevation-1"
      >
        <template v-slot:item.amount="{ item }">
          {{ item.currency }} {{ item.amount.toFixed(2) }}
        </template>
        <template v-slot:item.card_number="{ item }">
          {{ formatCard(item.card_number) }}
        </template>
        <template v-slot:item.customer="{ item }">
          {{ item.customer.name }}
          <template v-if="item.customer.business">
            | {{ item.customer.company_name }}
          </template>
        </template>
        <template v-slot:item.accepted="{ item }">
          <v-icon
            v-if="item.accepted"
            color="green"
          >
            check
          </v-icon>
          <v-icon
            v-else
            color="red"
          >
            not_interested
          </v-icon>
        </template>
        <template v-slot:item.created="{ item }">
          {{ formatQpDate(item.created_at) }}
        </template>
        <template v-slot:item.action="{ item }">
          <v-row justify="end">
            <v-icon
              medium
              class="mr-5"

              color="green"
              @click="editItem(item)"
            >
              remove_red_eye
            </v-icon>
          </v-row>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>
<script>
  import List from '@/mixins/List'

  export default {
    mixins: [List],
    data () {
      return {
        endpoint: 'payments/quickpay/subscriptions',
        name: 'subscription',
        headers: [
          {
            sortable: false,
            text: this.$t('id'),
            value: 'subscription_id',
          },
          {
            sortable: false,
            text: this.$t('card_number'),
            value: 'card_number',
          },
          {
            sortable: false,
            text: this.$t('card_type'),
            value: 'card_type',
          },
          {
            sortable: false,
            text: this.$t('customer'),
            value: 'customer',
            width: '100%',
          },
          {
            sortable: false,
            text: this.$t('state'),
            value: 'state',
          },
          {
            sortable: false,
            text: this.$t('ok').toUpperCase(),
            value: 'accepted',
          },
          {
            sortable: false,
            text: this.$t('created'),
            value: 'created',
          },
          { text: this.$t('actions'), value: 'action', sortable: false },

        ],
      }
    },
    methods: {
      formatCard (card) {
        return card ? card.match(/.{4}/g).join(' ') : card
      },
      formatQpDate (date) {
        return this.$moment(date).format('YYYY-MM-DD HH:mm:ss')
      },
      editItem: function ({ id }) {
        this.$router.push(`/payments/quickpay/subscription/${id}`)
      },
    },
  }
</script>
